module.exports = __webpack_public_path__ + "static/assets/b0eaae759470abf309ff6dd2ecf4a00d.svg";